import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {
  const portalRoot = useRef(document.getElementById('portal-root'));

  useEffect(() => {
    if (!portalRoot.current) {
      const div = document.createElement('div');
      div.id = 'portal-root';
      document.body.appendChild(div);
      portalRoot.current = div;
    }
  }, []);

  return portalRoot.current ? createPortal(children, portalRoot.current) : null;
};

export default Portal;
